<template>
  <!-- Grid -->
  <div class="grid">
    <div class="grid__content"
      v-observe>
      <div class="grid__column"
        v-animate-block="isAnimated">
        <div class="grid__element grid__element__only-small">
          <div>
            <img src="@/assets/img/sketch-logo.svg" alt="Sketch" width="200" height="200" />
            <p>Sketch</p>
          </div>
        </div>
        <div class="grid__element">
          <div>
            <img src="@/assets/img/github-logo.svg" alt="Github" width="200" height="200" />
            <p>Github</p>
          </div>
        </div>
        <div class="grid__element">
          <div>
            <img src="@/assets/img/netlify-logo.svg" alt="Netlify" width="200" height="200" />
            <p>Netlify</p>
          </div>
        </div>
        <div class="grid__element">
          <div>
            <img src="@/assets/img/firebase-logo.svg" alt="Firebase" width="200" height="200" />
            <p>Firebase</p>
          </div>
        </div>
      </div>
      <div class="grid__column grid__element__only-medium-large"
        v-animate-block="isAnimated">
        <div class="grid__element">
          <div>
            <img src="@/assets/img/sketch-logo.svg" alt="Sketch" width="200" height="200" />
            <p>Sketch</p>
          </div>
        </div>
        <div class="grid__element">
          <div>
            <img src="@/assets/img/psd-logo.svg" alt="Photoshop" width="200" height="200" />
            <p>Photoshop</p>
          </div>
        </div>
        <!-- <div class="grid__element grid__element__only-medium-large">
          <div>
            <img src="@/assets/img/visual-studio-logo.svg" alt="Visual Studio" width="200" height="200" />
            <p>Visual Studio</p>
          </div>
        </div> -->
      </div>
      <div class="grid__column"
        v-animate-block="isAnimated">
        <div class="grid__element grid__element__only-small">
          <div>
            <img src="@/assets/img/psd-logo.svg" alt="Photoshop" width="200" height="200" />
            <p>Photoshop</p>
          </div>
        </div>
        <div class="grid__element">
          <div>
            <img src="@/assets/img/vuejs-logo.svg" alt="Vuejs" width="200" height="200" />
            <p>VueJs</p>
          </div>
        </div>
        <div class="grid__element">
          <div>
            <img src="@/assets/img/graphql-logo.svg" alt="GraphQl" width="200" height="200" />
            <p>GraphQl</p>
          </div>
        </div>
        <!-- <div class="grid__element">
          <div>
            <img src="@/assets/img/docker-logo.svg" alt="Docker" width="200" height="200" />
            <p>Docker</p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- ./Grid -->
</template>

<script>
import anime from 'animejs'

export default {
  name: 'Grid',
  data: () => ({
    isAnimated: false
  }),
  directives: {
    'animate-block': {
      bind (el, binding, vnode) {
        anime.set(el.querySelectorAll('.grid__element'), {
          opacity: 0
        })
      },
      update (el, binding, vnode) {
        if (binding.value !== binding.oldValue) {
          anime({
            targets: el.querySelectorAll('.grid__element'),
            opacity: 1,
            easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)',
            duration: 1150,
            delay: anime.stagger(500)
          })
        }
      }
    },
    'observe': {
      bind (el, binding, vnode) {
        const options = {
          threshold: 0.25
        }
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              vnode.context.isAnimated = true
            }
          })
        }, options)

        observer.observe(el)
      }
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>
